<h1
  [ngStyle]="{
    'font-size': fontSize || '',
    'font-weight': fontWeight || '700'
  }"
>
  {{ text }}
</h1>
